<template>
  <div class="centros-layout">
    <div class="centros-header">
      <v-btn 
        rounded
        small
        fab
        color="primary" 
        @click="action_new"
      >
        <v-icon small>mdi-plus-thick</v-icon>
      </v-btn>
      <div>
        <ViewTitle title="Centros admin"/>
      </div>
      
      <v-tabs
        v-model="tab"
        color="primary"
        class="centros-tabs"
      >
        <v-tab v-for="tab in tabs" :key="tab" class="centros-tab">
          {{ tab }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="centros-layout-row">
          <CentroList
            :centros="current_centros"
            @action_new="action_new"
            @action_edit="action_edit"
            @action_delete="action_delete"
          />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="centros-layout-row">
          <CentroProcessesMatrix
            :centros="current_centros"
            @action_new="action_new"
            @action_edit="action_edit"
            @action_delete="action_delete"
          />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="centros-layout-row">
          <CentroUserRoles
            :centros="current_centros"
            @action_new="action_new"
            @action_edit="action_edit"
            @action_delete="action_delete"
          />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="centros-layout-row">
          <CentroManagers
            :centros="current_centros"
            @action_new="action_new"
            @action_edit="action_edit"
            @action_delete="action_delete"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>

    <ModalDialogForm
      :title="modal_title"
      :showModalDialog="show_modal_dialog"
      :fields_to_collect="fields_to_collect"
      submit_button_text="Save"
      validate
      @close-dialog="hide_dialog"
      @submit="submit_action"
      :loading="loading"
    />

    <ConfirmDialog ref="confirm_dialog" />
  </div>
</template>


<style lang="scss">
 @import "@/sass/menus.scss";
 @import "@/sass/explorer.scss";

 .centros-layout {
   display: flex;
   flex-direction: column;
   padding: 18px;
   width: 100%;
   min-height: 90%;
 }

 .centros-header {
   display: flex;
   flex-direction: row;
   padding: 0px;
   gap: 16px;
   align-items: center;
 }

 .centros-layout-row {
   display: flex;
   flex-direction: row;
   min-height: 100%;
   align-items: flex-start;
 }

 .centros-tabs {
   max-height: 48px;
 }

 .centros-tab {
   height: 64px !important;
 }
</style>


<script>
 import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
 import QCentro from '@/api/QCentro';
 import CentroList from '@/components/centro/CentroList';
 import CentroProcessesMatrix from '@/components/centro/CentroProcessesMatrix';
 import CentroUserRoles from '@/components/centro/CentroUserRoles';
 import CentroManagers from '@/components/centro/CentroManagers';
 import ModalDialogForm from '@/components/explorer/ModalDialog';
 import ConfirmDialog from '@/components/ConfirmDialog';
 import ViewTitle from '@/components/ViewTitle';
 const NOOP = () => {};

 const NO_PARENT = 'none';

 export default {
   name: 'Centros',

   components: {
     CentroList,
     ModalDialogForm,
     ConfirmDialog,
     CentroProcessesMatrix,
     CentroUserRoles,
     CentroManagers,
     ViewTitle,
   },

   data: () => ({
     loading: false,
     confirm_dialog_model: false,
     tab: 'list',
     modal_title: ';-)',
     show_modal_dialog: false,
     submit_action: NOOP,
     current_id: '',
     current_name: '',
     current_parent: null,
     current_url_name: null,
     current_logo: null,
     current_process_map_image: null,
     current_background_image: null,
     current_logo_name: '',
     current_process_map_image_name: '',
     current_background_image_name: '',
     confirm_resolve: NOOP,
     tabs: [
       'Lista de centros',
       'Matriz de procesos',
       'Roles y usuarios',
       'Managers',
     ],
   }),

   computed: {
     ...mapGetters(['site_id', 'user']),
     ...mapState(['isLoading', 'sites', 'centros']),

     fields_to_collect() {
       return [
         [
           {
             id: 'id',
             label: 'Centro Id',
             required: false,
             value: this.current_id,
             readonly: true,
             cols: 6,
             class: null,
             component: 'TextInput',
             placeholder: 'Automatic Id',
           },
         ], [
           {
             id: 'name',
             label: 'Centro name',
             required: true,
             value: this.current_name,
             readonly: false,
             cols: 4,
             class: null,
             component: 'TextInput',
             placeholder: "Centro's name",
           },
           {
             id: 'url_name',
             label: "Centro's URL access name",
             required: false,
             value: this.current_url_name,
             readonly: false,
             cols: 4,
             class: null,
             component: 'TextInput',
             placeholder: "Centro's URL access name",
           },
           {
             id: 'parent',
             label: "Parent Centro",
             required: true,
             value: this.current_parent || NO_PARENT,
             readonly: false,
             cols: 4,
             class: null,
             component: 'Select',
             placeholder: "Centro's URL access name",
             items: this.centros_as_items,
             multiple: false,
           },
         ], [
           {
             id: 'process_map_image',
             label: 'Processes map',
             required: false,
             value: null,
             readonly: false,
             cols: 4,
             class: null,
             component: 'FileInput',
             placeholder: this.current_process_map_image_name,
             mimetype: 'image',
             filename:  this.current_process_map_image_name
           },
           {
             id: 'logo',
             label: 'Logo',
             required: false,
             value: null,
             readonly: false,
             cols: 4,
             class: null,
             component: 'FileInput',
            //  placeholder: this.current_logo_name,
             mimetype: 'image',
             filename: this.current_logo_name,
           },
           {
             id: 'background_image',
             label: 'Background image',
             required: false,
             value: null,
             readonly: false,
             cols: 4,
             class: null,
             component: 'FileInput',
             placeholder: this.current_background_image_name,
             mimetype: 'image',
             filename: this.current_background_image_name,
           }
         ],
       ];
     },

     site_centros() {
       const res = {};
       for (const centro of Object.values(this.centros)) {
         if (centro.site == this.site_id) {
           res[centro.id] = centro;
         }
       }
       return res;
     },

     centros_as_items() {
       return ([[NO_PARENT, '--Sin-padre--']]).concat(
         Object.values(this.site_centros)
               .map(c => [c.id, c.name])
               .sort((a, b) => a[1].localeCompare(b[1])));
     },

     current_centros() {
       return this.site_centros;
     }
   },

   methods: {
     ...mapActions(['GET_CENTROS']),

     confirm_delete(centro) {
       // USAGE: await confirm_delete({centro})
       this.set_current(centro);
       this.confirm_dialog_model = true;
       return new Promise(resolve => {
         this.confirm_resolve = resolve;
       }).then(ok => {
         this.confirm_dialog_model = false;
         return ok;
       });
     },

     hide_dialog() {
       this.show_modal_dialog = false;
       this.modal_title = ``;
       // Reset current selection. Fix open same centro with empty values.
       this.set_current();
     },

     async set_current(centro) {
       // Param centro → Current centro object
       // Call with no parameter to reset
       const c = centro !== undefined ? centro : {};
       this.current_logo_name = c.logo ? c.logo.split("/").pop() : "";
       console.log(c.process_map_image)
       this.current_process_map_image_name = c.process_map_image ? c.process_map_image.split("/").pop() : "";
       this.current_background_image_name = c.background_image ? c.background_image.split("/").pop() : "";
       this.current_id                = c.id                || '';
       this.current_name              = c.name              || '';
       this.current_parent            = c.parent            || '';
       this.current_url_name          = c.url_name          || '';
       this.current_logo              = c.logo              || null;
       this.current_process_map_image = c.process_map_image || null;
       this.current_background_image  = c.background_image  || null;
       await this.$nextTick();
     },

     async action_new(parent_id) {
       let cdata = undefined;
       if (parent_id) {
         cdata = {parent: parent_id};
       }
       await this.set_current(cdata);
       this.modal_title = `Create a new Centro`;
       this.submit_action = this.save_new;
       this.show_modal_dialog = true;
       console.log('ACTION NEW', cdata);
     },

     async action_edit(centro_id) {
       const cdata = this.centros[centro_id];
       await this.set_current(cdata);
       this.modal_title = `Edit Centro ${cdata.name}`;
       this.submit_action = this.save_edit;
       this.show_modal_dialog = true;
     },

     process_form_data(fd) {
       if (fd.get('parent') == NO_PARENT) {
         fd.delete('parent');
         fd.set('parent', '');
       }
       return fd;
     },

     async action_delete(centro_id) {
       const centro = this.centros[centro_id];
       const ok = await this.$refs.confirm_dialog.launch({
         title: `Delete ${centro.name}`,
         text: `Do you want to permanently delete center "${centro.name}" with id ${centro.id} ?`,
         yes: 'Yes, destroy it',
         no: 'No, keep it',
         yes_last: false,
       });
       console.log(ok);
       // TODO: If ok → send delete and update
     },

     async save_new(form_data) {
       form_data = this.process_form_data(form_data);
       try {
         this.loading = true;
         await QCentro.post(this.site_id, form_data);
         this.show_modal_dialog = false;
         this.GET_CENTROS();
       } catch (err) {
         console.error("Centros.save_new exception ", err);
       }
       this.loading = false;
     },

     async save_edit(form_data) {
       form_data = this.process_form_data(form_data);
       try {
         this.loading = true;
         await QCentro.put(this.site_id, this.current_id, form_data);
         this.show_modal_dialog = false;
         this.GET_CENTROS();
       } catch (err) {
         console.error("Centros.save_edit exception ", err);
       }
       this.loading = false;
     },
   },
 }
</script>
